import { firestoreAction } from 'vuexfire'
import * as firebase from 'firebase'
import db from '@/db'
import { setTimeout } from 'timers'

const orgRef = db.collection('organization')
const userRef = db.collection('users')
const storageRef = firebase.default.storage().ref()
const updated = firebase.default.firestore.FieldValue.serverTimestamp()

const initialState = {
  organization: {},
  organizationLoading: true
}

const state = Object.assign({}, initialState)

const mutations = {
  'SET_ORGANIZATON_LOADING' (state, loading) {
    state.organizationLoading = loading
  },
  'SET_ORGANIZATION' (state, organization) {
    state.organization = organization
  },
  'RESET_STATE' (state) {
    for (let prop in state) {
      state[prop] = initialState[prop]
    }
  }
}

const actions = {
  initOrganization: ({ commit }) => {
    commit('SET_ORGANIZATION')
  },
  setOrganizationRef: firestoreAction(({ bindFirestoreRef, dispatch, commit }, ref) => {
    bindFirestoreRef('organization', ref).then(org => {
      if (org) {
        const estimatesRef = db.collection('estimates').where('organization', '==', org.id).orderBy('created')
        const tasksRef = db.collection('tasks').where('organization', '==', org.id).orderBy('estimate')
        const ratesRef = db.collection('rates').where('organization', '==', org.id).orderBy('created')
        const redFlagsRef = db.collection('redFlags').where('organization', '==', org.id).orderBy('created')
        const rolesRef = db.collection('roles').where('organization', '==', org.id).orderBy('name')
        const teamRef = db.collection('team').where('organization', '==', org.id).orderBy('fullName')
        dispatch('setEstimatesRef', estimatesRef)
        dispatch('setTasksRef', tasksRef)
        dispatch('setRatesRef', ratesRef)
        dispatch('setRedFlagsRef', redFlagsRef)
        dispatch('setRolesRef', rolesRef)
        dispatch('setTeamRef', teamRef)
      }
      commit('SET_ORGANIZATON_LOADING', false)
      dispatch('saveState', true)
      dispatch('toggleLoading', false)
    })
      .catch(error => {
        console.log(error)
      })
  }),
  addOrganization: firestoreAction(({ dispatch, bindFirestoreRef, commit }, payload) => {
    return new Promise((resolve, reject) => {
      orgRef.add(payload).then(org => {
        let userInfo = {
          updated: updated,
          selectedOrganization: org.id
        }
        const orgKey = 'organizations.' + org.id
        userInfo[orgKey] = {
          name: payload.name
        }
        userRef.doc(payload.owner).update(userInfo).then(response => {
          bindFirestoreRef('organization', orgRef.doc(org.id)).then(response => {
            dispatch('resetRoleState')
            dispatch('resetTeamState')
            dispatch('resetEstimateState')
            dispatch('resetRateState')
            dispatch('resetRedFlagState')
            dispatch('resetTaskState')
            commit('RESET_STATE')
            dispatch('setOrganizationRef', orgRef.doc(org.id)).then(response => {
              if (org.id) {
                resolve(org.id)
              } else {
                reject(new Error('There was a problem with the connection. Try refreshing your browser.'))
              }
            })
            dispatch('saveState', true)
            dispatch('toggleLoading', false)
          })
        }).catch(error => {
          console.log(error)
        })
      })
    })
  }),
  joinOrganization: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      const docRef = orgRef.doc(payload.code)
      docRef.get().then(doc => {
        if (doc.exists) {
          const batch = db.batch()

          // Update organization
          let orgInfo = {
            updated: updated
          }
          const memberString = 'members.' + payload.user
          orgInfo[memberString] = {
            username: payload.userName,
            avatar: payload.avatar
          }
          const orgUpdate = orgRef.doc(payload.code)
          batch.update(orgUpdate, orgInfo)

          // Update user
          const userInfo = {
            selectedOrganization: payload.code,
            updated: updated
          }
          userInfo['organizations.' + [payload.code] + '.name'] = doc.data().name
          const userUpdate = userRef.doc(payload.user)
          batch.update(userUpdate, userInfo)
          // Commit changes
          batch.commit().then(response => {
            dispatch('setOrganizationRef', orgRef.doc(payload.code))
            dispatch('setRedirect', false)
            dispatch('saveState', true)
          })
          resolve()
        } else {
          reject(new Error('Oops. That’s an invalid code. Try again?'))
        }
      }).catch(error => {
        console.log(error)
      })
    })
  },
  duplicateOrganization: ({ dispatch }, payload) => {
    dispatch('toggleLoading', true)
    const orgData = { ...state.organization }
    const newOrgName = orgData.name + ' Copy'
    orgData.name = newOrgName
    orgData.created = updated
    orgData.updated = updated
    orgData.members = {}
    orgData.members[payload.user] = {
      username: payload.userName,
      avatar: payload.avatar
    }
    orgData.owner = payload.user
    // delete orgData.id
    orgData.estimates = false
    orgData.rates = false
    orgData.redFlags = false
    orgData.roles = false
    orgData.tasks = false
    orgData.team = false
    orgRef.add(orgData).then(org => {
      const batch = db.batch()
      // Copy to user
      const userInfo = {
        selectedOrganization: org.id,
        updated: updated
      }
      const orgKey = 'organizations.' + org.id
      userInfo[orgKey] = {
        name: newOrgName
      }
      const userUpdate = userRef.doc(payload.user)
      batch.update(userUpdate, userInfo)
      // Commit changes and switch to new org
      batch.commit().then(response => {
        console.log('Batch complete')
        console.log(response)
        const orgDetails = {
          user: payload.user,
          orgName: newOrgName,
          org: org.id
        }
        dispatch('duplicateRoles', orgDetails).then(roleResponse => {
          console.log('Duplicted roles')
          const rfPayload = orgDetails
          rfPayload.roles = roleResponse
          dispatch('duplicateRedFlags', rfPayload).then(rfResponse => {
            dispatch('duplicateRates', orgDetails).then(rateResponse => {
              dispatch('duplicateTeam', orgDetails).then(teamResponse => {
                const estPayload = orgDetails
                estPayload.roles = roleResponse
                estPayload.team = teamResponse
                estPayload.rates = rateResponse
                estPayload.redFlags = rfResponse
                dispatch('duplicateEstimates', estPayload).then(estResponse => {
                  const taskPayload = orgDetails
                  taskPayload.estimates = estResponse
                  taskPayload.person = teamResponse
                  taskPayload.role = roleResponse
                  dispatch('duplicateAllTasks', taskPayload).then(taskResponse => {
                    dispatch('changeOrganization', orgDetails).then(response => {
                    }).catch(error => {
                      console.log(error)
                    })
                  }).catch(error => {
                    console.log(error)
                  })
                }).catch(error => {
                  console.log(error)
                })
              }).catch(error => {
                console.log(error)
              })
            }).catch(error => {
              console.log(error)
            })
          }).catch(error => {
            console.log(error)
          })
        }).catch(error => {
          console.log(error)
        })
      }).catch(error => {
        console.log(error)
      })
    }).catch(error => {
      console.log(error)
    })
  },
  changeOrganization: ({ dispatch }, payload) => {
    dispatch('toggleLoading', true)
    userRef.doc(payload.user).update({
      selectedOrganization: payload.org
    }).then(response => {
      setTimeout(delay => {
        dispatch('setOrganizationRef', orgRef.doc(payload.org))
      }, 3000)
    })
  },
  updateOrganization: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      let update = { ...payload }
      const updateOrg = (update) => {
        update.updated = updated
        orgRef.doc(update.id).update(update).then(org => {
          Object.keys(update.members).forEach(member => {
            const memberUpdate = {}
            memberUpdate.updated = update.updated
            memberUpdate['organizations.' + [update.id] + '.name'] = update.name
            userRef.doc(member).update(memberUpdate).then(response => {
              dispatch('saveState', true)
            }).catch(error => {
              console.log(error)
            })
          })
          dispatch('saveState', true)
          resolve(org)
        }).catch(error => {
          reject(error)
          console.log(error)
        })
      }
      if (payload.logo) {
        console.log(payload.logo)
        const filename = update.logo.name
        const ext = filename.slice(filename.lastIndexOf('.'))
        const uploadTask = storageRef.child('logos/' + update.id + '.' + ext).put(update.logo)
        uploadTask.on(firebase.default.storage.TaskEvent.STATE_CHANGED, (snapshot) => {
          let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          console.log('Upload is ' + progress + '% done')
          switch (snapshot.state) {
            case firebase.default.storage.TaskState.PAUSED:
              console.log('Upload is paused')
              break
            case firebase.default.storage.TaskState.RUNNING:
              console.log('Upload is running')
              break
          }
        }, (error) => {
          switch (error.code) {
            case 'storage/unauthorized':
              reject(error)
              break
            case 'storage/canceled':
              reject(error)
              break
            case 'storage/unknown':
              reject(error)
              break
          }
        }, () => {
          uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            update.logo = downloadURL
            updateOrg(update)
          })
        })
      } else {
        updateOrg(update)
      }
    })
  }
}

const getters = {
  organizationLoading: state => {
    return state.organizationLoading
  },
  organization: state => {
    return state.organization
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
